import { render, staticRenderFns } from "./RightGroupsDialog.vue?vue&type=template&id=66dfa52a&scoped=true&"
import script from "./RightGroupsDialog.vue?vue&type=script&lang=js&"
export * from "./RightGroupsDialog.vue?vue&type=script&lang=js&"
import style0 from "./RightGroupsDialog.vue?vue&type=style&index=0&id=66dfa52a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66dfa52a",
  null
  
)

export default component.exports